export const APPOINTMENT_STAGE_NONE = 0
export const APPOINTMENT_STAGE_PATIENT = 1
export const APPOINTMENT_STAGE_LIST = 2
export const APPOINTMENT_STAGE_NEW = 3
export const APPOINTMENT_STAGE_CONFIRMED = 4
export const APPOINTMENT_STAGE_CANCELLED = 5